export default __webpack_public_path__ + "static/uploadproductapi-snapshot-861dd1ac5044066f68c1d24460ff6c00.jpg";